import { all, apply, put, takeLatest } from 'redux-saga/effects';

import { getSingleton } from '@occc-app/Activate/api';
import { Limit as LimitAPI } from '@occc-app/Activate/apiTypes';
import { safeAsync } from '@occc-app/lib/safeAsync';

import actions from './actions';
import { deserializeLimit, deserializeLimitType } from './deserializers';

import { types as offerTypes, ActionCreators as OfferActionCreators } from '../../../redux';

// Request Limits
function* requestLimit(id: string, apiLimit: LimitAPI['attributes']['limit_type']) {
  const core = getSingleton();
  try {
    const limitType = deserializeLimitType(apiLimit);
    yield put(actions.requestLimit(id, limitType));

    const limitData = (yield apply(core, core.limits.id(id).show, [{}])) as {
      data: LimitAPI;
    };

    const selectedLimit = deserializeLimit(limitData.data);

    // Hack Limits have a limit of null, and should not be considered part of an Offer's Components
    if (selectedLimit.limit === null) {
      return;
    }

    yield put(actions.requestLimitOK(selectedLimit));
  } catch (error) {
    const errorMessages = error.errorMessages || [
      {
        message: `Unable to request Limit: ${apiLimit}`,
      },
    ];
    yield put(actions.requestLimitERR(errorMessages, error));
    throw error;
  }
}

function* requestLimits(action: ReturnType<OfferActionCreators['RequestOfferOK']>) {
  yield all(action.limits.map((limit) => requestLimit(limit.id!, limit.attributes.limit_type)));
  yield put(actions.requestLimitsOK());
}

const sagas = {
  requestLimits: safeAsync(requestLimits),
};

export default function* saga() {
  yield takeLatest(offerTypes.REQUEST_OFFER_OK, sagas.requestLimits);
}
